import React from 'react'
import {
  Route,
  Redirect,
  Switch
} from "react-router-dom";
import ForgotPassword from '../components/Auth/ForgotPassword';

import Login from '../components/Auth/Login';
import NoMatch from './NoMatch';
import Welcome from '../components/Auth/WelcomeSignup';

function NonAuthRoutes(){

    return <Switch>
        <Route exact path="/login">
            <Login />
        </Route>
        <Route path="/welcome/:salesToken" component={Welcome} />
        <Route exact path="/welcome">
            <Welcome />
        </Route>
        <Route exact path="/forgot-password">
            <ForgotPassword />
        </Route>
        <Route exact path="/verify/:code" component={Login} />
        <Route exact path="/">
            <Redirect to="/login" />
        </Route>
        <Route path="*">
            <NoMatch redirect="/login" />
        </Route>
    </Switch>
}

export default NonAuthRoutes